// extracted by mini-css-extract-plugin
export default {"hstack":"hstack_hstack__h4ejI"};